import React, { useEffect, useState } from 'react'
import { Button, Icon, Table } from 'semantic-ui-react'
import moment from 'moment'
import { getSignedUrls, getHistoryDocuments, retryJob } from '../../../../commonApis/getGBForm'
import { showToast } from '@commonComponents/showToast'


const HiistoryDetails = ({ onClose }) => {
  const [history, setHistory] = useState([])
  const [expandedRows, setExpandedRows] = useState([])

  const handleRowClick = (index, id, children) => {
    let updatedHistory = [...history]
    let expand = expandedRows.includes(id)
    if (expand) {
      updatedHistory.splice(index + 1, children.length)
      let ids = expandedRows.filter((idx) => idx != id)
      setExpandedRows(ids)
    } else {
      setExpandedRows((prevState) => [...prevState, id])
      updatedHistory.splice(index + 1, 0, ...children)
    }
    setHistory(updatedHistory)
  }

  const getHistory = async () => {
    const response = await getHistoryDocuments(window.shipmentId)
    if (response) {
      setHistory(response?.data?.eventMessage?.fileUpload || [])
    }
  }
  useEffect(() => {
    getHistory()
  }, [])

  const handleRetryJob = async (jobId) => {
    const response = await retryJob(jobId)
    if (response) {
      showToast(response.data.eventMessage.msg, undefined, 'fileUploadHistory')
    }
  }

  return (
    <>
      <div className='fileUploadHistory toast'></div>
      <h2>History</h2>
      <div className='force-scrollbar historyTable'>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ID</Table.HeaderCell>
              <Table.HeaderCell>Document Name</Table.HeaderCell>
              <Table.HeaderCell>Version</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Link</Table.HeaderCell>
              <Table.HeaderCell>Retry</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {history?.length
              ? history?.map((item, index) => {
                  return (
                    <Table.Row
                      style={{
                        cursor: item?.childRecords?.fileUpload && 'pointer',
                        backgroundColor: item?.childRecords?.fileUpload && '#E8E8E8',
                      }}
                      onClick={() => {
                        item?.childRecords?.fileUpload &&
                          handleRowClick(index, item?.id, item?.childRecords?.fileUpload)
                      }}
                      key={item?.id}
                    >
                      <Table.Cell>
                        {item?.childRecords?.fileUpload &&
                          (expandedRows.includes(item?.id) === true ? (
                            <Icon name='angle up' size='small' circular color='blue' />
                          ) : (
                            <Icon name='angle down' size='small' circular color='blue' />
                          ))}
                        {item?.id}{' '}
                      </Table.Cell>
                      <Table.Cell>{item?.documentName}</Table.Cell>
                      <Table.Cell>{item?.version}</Table.Cell>
                      <Table.Cell>{item?.status ? item?.status : null}</Table.Cell>
                      <Table.Cell>
                        {item?.date
                          ? moment(Number(item?.date)).format('MMMM Do YYYY, h:mm a')
                          : null}
                      </Table.Cell>
                      <Table.Cell>
                        {item?.cdsS3URL && (
                          <Button
                            basic
                            color='blue'
                            onClick={async () => {
                              let url = await getSignedUrls({ files: [item?.cdsS3URL] })
                              console.log(url)
                              window.open(url?.data.eventMessage?.urls[0])
                            }}
                          >
                            See Document
                          </Button>
                        )}
                      </Table.Cell>
                      <Table.Cell>
                        {  !item?.childRecords?.fileUpload?.length &&
                          item?.status==='FAILED' && (
                            <Button basic color='blue' onClick={() => handleRetryJob(item?.jobId)}>
                              Retry
                            </Button>
                          )
                        }
                      </Table.Cell>
                    </Table.Row>
                  )
                })
              : null}
          </Table.Body>
        </Table>
      </div>
      <Button floated='left' color='blue' style={{ margin: '10px 0px' }} onClick={onClose}>
        Close
      </Button>
    </>
  )
}

export default React.memo(HiistoryDetails)
